import useSourceFlowCollection from "@/hooks/useSourceFlowCollection";
import data from "@sourceflow/useful_links.json";

export const useUsefulLinks = () => useSourceFlowCollection(data);

export default useUsefulLinks;
